import { createAction, props } from '@ngrx/store';
export const setComplianceDesignationTypeOption = createAction('[Compliance Report History Page] Set Designation Type Option', props());
